import { IFormLogin } from './login.interface';
import { ILoginRequestAction, LoginTypes } from './login.type';

export const login = (payload: IFormLogin): ILoginRequestAction => ({
	type: LoginTypes.LOGIN,
	payload,
});
